module.exports = __webpack_public_path__ + "static/media/whmcs.713519da.svg";